import {
  Devis,
  DevisFormData,
  FactureEmise,
  FactureEmiseFormData,
  ModelDevis,
  UserInfos,
} from "../../redux/types";

export type DevFact = Devis | FactureEmise;
export type Dev = DevFact | DevisFormData | FactureEmiseFormData;

export async function generateDevis(
  item: Dev,
  model: ModelDevis,
  user: UserInfos,
  signature?: string,
) {
  return generate(item, model, user, false, signature);
}

export async function generateFacture(
  item: FactureEmise,
  model: ModelDevis,
  user: UserInfos,
  signature?: string,
  date?: string,
) {
  return generate(item, model, user, true, signature, date);
}

export async function generate(
  item: Dev | FactureEmise,
  model: ModelDevis,
  user: UserInfos,
  isFacture: boolean,
  signature?: string,
  date?: string,
) {
  const data = JSON.stringify({
    devis: item,
    model: model,
    user: user,
    isFacture: isFacture,
    date: date || null,
    signature: signature || null,
  });
  const response = await fetch(
    "https://api.fastfacture.com/api/update-devis-html-v2",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: data,
    },
  );

  if (!response.ok) {
    console.log(`HTTP error! status: ${response.status}`);
  }
  const result = await response.json();
  console.log({ result });
  return result;
}
